import { Modal } from "@pacificoseguros/pixie/react/modal";
import React, { useCallback } from "react";
import iconPlanilla from "../../../assets/icons/ic-planilla.svg";
import { Column } from "../../../components/layout/flex-layout";
import { SizedBox } from "../../../components/layout/sized-box";
import { SpacingBox } from "../../../components/layout/spacing-box";
import { Typography } from "../../../components/typography/typography";
import { DatalayerModal } from "../../../libs/datalayer/components/datalayer-modal";
import { DatalayerModalPixieButton } from "../../../libs/datalayer/components/datalayer-modal-pixie-button";
import { useLanding } from "../providers/landing-provider";

export const LandingWorkersPayRollModal = () => {
    const { isOpenedPayrollModal, setOpenedPayrollModal } = useLanding();
    const close = useCallback(() => setOpenedPayrollModal(false), []);
    return (
        isOpenedPayrollModal && (
            <DatalayerModal
                data-testid="LandingWorkersPayRollModal"
                open={isOpenedPayrollModal}
                type="Informativo"
                name="Planilla de trabajadores"
                as={Modal}
                onClose={close}
            >
                <SpacingBox p={20}>
                    <SizedBox width={260}>
                        <Column align="center">
                            <img src={iconPlanilla} width={49} alt="planilla" />
                            <SpacingBox mb={24} />
                            <Typography fontSize={20}>
                                <b>Planilla de trabajadores</b>
                            </Typography>
                            <SpacingBox mb={19} />
                            <Typography fontSize={16}>
                                Los datos que necesitamos para completar el
                                archivo son: Documento de Identidad (DNI),
                                nombres completos, fecha de nacimiento,
                                nacionalidad y sueldo mensual de todos tus
                                trabajadores en planilla.
                            </Typography>
                            <SpacingBox mb={30} />
                            <DatalayerModalPixieButton
                                kind="secondary"
                                inverse
                                fluid
                                onClick={close}
                                label="Volver"
                            >
                                Volver
                            </DatalayerModalPixieButton>
                        </Column>
                    </SizedBox>
                </SpacingBox>
            </DatalayerModal>
        )
    );
};
